import { defineMessages } from "react-intl";

export default defineMessages({
  "generic.validation.errors": {
    id: "generic.validation.errors",
    defaultMessage: "One or more validation errors occurred."
  },
  "generic.dbupdate.exception": {
    id: "generic.dbupdate.exception",
    defaultMessage: "Microsoft.EntityFrameworkCore.DbUpdateException"
  }
})